/* New header — mega-menu promo image slideshow.
   Rotates the .mega-menu-slideshow__img elements driven by the
   shop metafield custom.header_slideshow. No dependencies. */
(function () {
  function initSlideshow(box) {
    var imgs = box.querySelectorAll('.mega-menu-slideshow__img');
    if (imgs.length < 2) return;

    var index = 0;
    var interval = parseInt(box.getAttribute('data-interval'), 10) || 2000;

    setInterval(function () {
      imgs[index].classList.remove('is-active');
      index = (index + 1) % imgs.length;
      imgs[index].classList.add('is-active');
    }, interval);
  }

  function init() {
    var boxes = document.querySelectorAll('[data-mega-slideshow]');
    for (var i = 0; i < boxes.length; i++) {
      initSlideshow(boxes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
